import React from 'react';
import {ViewMode} from '../../enums/ViewMode';
import PaginatedCollection from '../PaginatedCollection';
import {ILocation} from '../../types/resources/Location';
import LocationCard from './LocationCard';
import LocationListItem from "./LocationListItem";
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import GridCollection from '../GridCollection';

type TProps = {
    locations: ILocation[];
}

const LocationCollection = ({ locations }: TProps) => {
    const { locationViewMode } = useSettingsContext();
    const viewMode = locationViewMode as ViewMode;

    const renderCard = (location: ILocation, index: number) => (
        <LocationCard key={index} location={location}/>
    );

    const renderListItem = (location: ILocation, index: number) => (
        <LocationListItem key={index} location={location} />
    );

    const hasLocations = (locations.length > 0);

    return hasLocations ? (
            <div className="cr-py-xl cr-container">
                <PaginatedCollection
                    id={'locationCollection'}
                    items={locations as ILocation[]}
                    renderItems={{
                        [ViewMode.GridView]: renderCard,
                        [ViewMode.ListView]: renderListItem,
                    }}
                    itemsPerPage={Infinity}
                    itemsPerRow={3}
                    itemsPerRowTablet={2}
                    itemsPerRowMobile={1}
                    viewMode={viewMode}
                />
            </div>
    ) : null;
}

export default LocationCollection;
